const state = {
  filters: null,
}

export default {
  state,
}